<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Transaction Enquiry</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <TransactionHistoryTable mode="all-transaction-history" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * All Transaction History View
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import TransactionHistoryTable from "../../components/Kleyton/Tables/TransactionsHistory/TransactionHistoryTable";

export default {
  name: "AllTransactionHistory",
  page: {
    title: "Transaction Enquiry",
    meta: [{ name: "Transaction Enquiry", content: window.__env.app.description }]
  },
  components: {
    TransactionHistoryTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Transaction Enquiry",

      items: [
        {
          text: "Transaction Enquiry",
          href: "/"
        },
        {
          text: "Transaction Enquiry",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
